export default __webpack_public_path__ + "pgnv-assets/6a5db4e00551e268747b60589c01314a.svg";